import useAsyncData from 'src/utils/useAsyncData';
import { getOrganizationBanksAPI } from 'src/serverApi/banks';

const useOrganizationBanks = () => {
  const [fetchOrganizationBanks, wasOrganizationBanksFetched, isOrganizationBanksLoading, organizationBanks, organizationBanksError] = useAsyncData(
    getOrganizationBanksAPI
  );

  return {
    fetchOrganizationBanks,
    wasOrganizationBanksFetched,
    isOrganizationBanksLoading,
    organizationBanks,
    organizationBanksError,
  };
};

export default useOrganizationBanks;
